var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    id: "fc-calendar-container",
    class: "h-screen flex relative"
};
const _hoisted_2 = {
    key: 0,
    class: "absolute inset-0 w-loader h-3/4 bg-white/20 backdrop-blur-sm rounded-md z-20"
};
const _hoisted_3 = { class: "flex flex-col justify-center items-center h-full" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, "Loading calendar...", -1);
const _hoisted_5 = { class: "flex-1 h-full relative" };
const _hoisted_6 = {
    key: 0,
    class: "absolute top-1 z-10 text-[10px] break-words text-center w-[55px] font-medium"
};
import calendarWidgetStates from '@/helper/calendarWidgetStates';
import { ACTIVE_CALENDARS_LS_KEY_FN, ACTIVE_GROUPS_LS_KEY_FN, ACTIVE_TAB_SELECTION_FN, ACTIVE_USERS_LS_KEY_FN, ACTIVE_VIEW_LS_KEY_FN, FullCalendarLanguageKeysMapper, GHLLanguageKeysMapper, } from '@/helper/const';
import { assignEventColor, getEntityResources, getGMTOffset, retainDateFromTimeZoneChange, showViewAppointment, } from '@/helper/helper';
import allLocales from '@fullcalendar/core/locales-all';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import scrollGridPlugin from '@fullcalendar/scrollgrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import FullCalendar from '@fullcalendar/vue3';
import { UIContentWrap, UISpin } from '@gohighlevel/ghl-ui';
import _ from 'lodash';
import moment from 'moment-timezone';
import { onBeforeUnmount, onMounted, ref, toRaw, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import EventTile from './EventTile.vue';
import SideDrawer from './SideDrawer.vue';
import ToolBar from './ToolBar.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CalendarView',
    props: {
        userId: String,
        locationId: String,
        timezone: String,
        calendars: {
            type: Array,
            default: () => [],
        },
        groups: {
            type: Array,
            default: () => [],
        },
        users: {
            type: Array,
            default: () => [],
        },
        router: Object,
        isLoading: Boolean,
        data: null,
        updateEventOnDrag: Function,
    },
    setup(__props) {
        const props = __props;
        const fullCalendar = ref(null);
        const initialView = ref('timeGridWeek');
        const currentRange = ref({
            start: '',
            end: '',
        });
        const currentDate = ref();
        const { t } = useI18n();
        const fullCalendarRef = ref(null);
        const activeDate = ref(new Date());
        const calendarOptions = ref({
            plugins: [
                dayGridPlugin,
                interactionPlugin,
                timeGridPlugin,
                momentTimezonePlugin,
                resourceTimeGridPlugin,
                scrollGridPlugin,
            ],
            locales: allLocales,
            locale: 'en-us',
            schedulerLicenseKey: process.env.VUE_APP_FC_CALENDAR_LICENSE_KEY,
            timeZone: props.timezone,
            firstDay: 0,
            scrollTime: moment().tz(props.timezone).format('HH:mm:ss').startsWith('00')
                ? moment().tz(props.timezone).format('HH:mm:ss')
                : moment().tz(props.timezone).subtract(1, 'hour').format('HH:mm:ss'),
            // 0 for Sunday, 1 for Monday, 2 for Tuesday, etc.,
            selectable: true,
            eventLimit: true,
            dayMaxEvents: 15,
            select: function (info) {
                if (moment(info.startStr).isBefore(moment().format())) {
                    return;
                }
                if (initialView.value == 'timeGridDay') {
                    calendarWidgetStates.resourceDragData = {
                        type: calendarWidgetStates.activeView,
                        id: info.resource._resource.extendedProps.meta,
                        isActive: true,
                    };
                }
                calendarWidgetStates.bookAppointmentUsingDrag = true;
                calendarWidgetStates.bookAppointmentModal.show = true;
                if (info.allDay) {
                    if (moment(info.startStr).isBefore(moment().format())) {
                        return;
                    }
                    const startTime = moment
                        .tz(info.startStr, props.timezone)
                        .startOf('day')
                        .format();
                    const endTime = moment
                        .tz(info.endStr, props.timezone)
                        .endOf('day')
                        .subtract(1, 'day')
                        .format();
                    calendarWidgetStates.bookAppointmentModal.startTime = startTime;
                    calendarWidgetStates.bookAppointmentModal.endTime = endTime;
                }
                else {
                    calendarWidgetStates.bookAppointmentModal.startTime = info.startStr;
                    calendarWidgetStates.bookAppointmentModal.endTime = info.endStr;
                }
            },
            nowIndicator: true,
            editable: true,
            eventDrop: function (info) {
                var _a;
                const { event } = info;
                if ((_a = event === null || event === void 0 ? void 0 : event.extendedProps) === null || _a === void 0 ? void 0 : _a.isLongEvent) {
                    return;
                }
                if (event.extendedProps.ogEvent.status === 'booked' ||
                    (event.extendedProps.ogEvent.local &&
                        event.extendedProps.ogEvent.status === 'unavailable')) {
                    props.updateEventOnDrag(event.extendedProps.ogEvent.id, event.extendedProps.ogEvent.calendarId, true, props.locationId, event.extendedProps.ogEvent.contactId, event.title, event.extendedProps.ogEvent.calendarNotes, event.start, event.end, props.timezone, event.extendedProps.ogEvent.appointmentStatus, true, false, 'calendar_page', 'web_app', event.extendedProps.ogEvent.meetingLocationType, event.extendedProps.ogEvent.assignedUserId);
                }
            },
            eventResize: function (info) {
                var _a;
                const { event } = info;
                if ((_a = event === null || event === void 0 ? void 0 : event.extendedProps) === null || _a === void 0 ? void 0 : _a.isLongEvent) {
                    return;
                }
                if (event.extendedProps.ogEvent.status === 'booked' ||
                    (event.extendedProps.ogEvent.local &&
                        event.extendedProps.ogEvent.status === 'unavailable')) {
                    props.updateEventOnDrag(event.extendedProps.ogEvent.id, event.extendedProps.ogEvent.calendarId, true, props.locationId, event.extendedProps.ogEvent.contactId, event.title, event.extendedProps.ogEvent.calendarNotes, event.start, event.end, props.timezone, event.extendedProps.ogEvent.appointmentStatus, true, false, 'calendar_page', 'web_app', event.extendedProps.ogEvent.meetingLocationType, event.extendedProps.ogEvent.assingnedUserId);
                }
            },
            eventMinHeight: 20,
            initialView: 'timeGridWeek',
            views: {
                week: {
                    dayHeaderFormat: {
                        day: '2-digit',
                        weekday: 'short',
                    },
                },
            },
            headerToolbar: false,
            height: '75%',
            events: calendarWidgetStates.events || [],
            resources: [],
            weekends: true,
            allDayContent: t('calendarOverlay.all_day'),
            eventClick: function (info) {
                const popover = document.querySelector('.fc-popover');
                if (popover) {
                    popover.remove();
                }
                showViewAppointment(info.event, props.timezone, calendarWidgetStates, props.data);
            },
        });
        watchEffect(() => {
            if (calendarWidgetStates.filterValue == 'Blocked Slots') {
                calendarOptions.value.events = calendarWidgetStates.events.filter((item) => item.ogEvent.status == 'unavailable');
            }
            else if (calendarWidgetStates.filterValue == 'Appointment') {
                calendarOptions.value.events = calendarWidgetStates.events.filter((item) => item.ogEvent.status == 'booked');
            }
            else {
                calendarOptions.value.events = calendarWidgetStates.events = [
                    ...calendarWidgetStates.events,
                ];
            }
        });
        watchEffect(() => {
            calendarOptions.value.events = toRaw(calendarWidgetStates.events.map(item => {
                var _a, _b;
                if (initialView.value == 'dayGridMonth') {
                    return Object.assign(Object.assign({}, item), { allDay: true, editable: false });
                }
                else {
                    return Object.assign(Object.assign({}, item), { allDay: item.allDay, editable: (item === null || item === void 0 ? void 0 : item.isLongEvent)
                            ? false
                            : ((_a = item === null || item === void 0 ? void 0 : item.ogEvent) === null || _a === void 0 ? void 0 : _a.local) || ((_b = item === null || item === void 0 ? void 0 : item.ogEvent) === null || _b === void 0 ? void 0 : _b.status) === 'booked' });
                }
            }));
        });
        watchEffect(() => {
            calendarOptions.value.firstDay = calendarWidgetStates.startDayOfWeek;
            calendarOptions.value.resources = getEntityResources(calendarWidgetStates.activeView, calendarWidgetStates.userIds, assignEventColor(props.users), calendarWidgetStates.calendarIds, props.calendars, calendarWidgetStates.groupIds, props.groups);
            calendarOptions.value.locale =
                FullCalendarLanguageKeysMapper[props.data.locale] || 'en-us';
        });
        function fetchOnChange(calendar) {
            const activeView = calendar.view;
            const activeStartDate = activeView.activeStart;
            const activeEndDate = activeView.activeEnd;
            currentDate.value = calendar.currentData.viewTitle;
            currentRange.value.start = activeStartDate.toISOString();
            currentRange.value.end = activeEndDate.toISOString();
            calendarWidgetStates.start = moment
                .tz(currentRange.value.start, props.timezone)
                .startOf('day')
                .format();
            calendarWidgetStates.end = moment
                .tz(currentRange.value.end, props.timezone)
                .endOf('day')
                .format();
        }
        function handleCustomNavigation(action) {
            if (action == 'prev') {
                fullCalendarRef.value.prev();
            }
            else if (action == 'next') {
                fullCalendarRef.value.next();
            }
            else if (action == 'today') {
                fullCalendarRef.value.today();
            }
            activeDate.value = fullCalendarRef.value.getDate();
            fetchOnChange(fullCalendarRef.value);
        }
        function toggleView(view) {
            const isResourceView = view === 'timeGridDay';
            fullCalendarRef.value.changeView(isResourceView ? 'resourceTimeGridDay' : view);
            initialView.value = view;
            if (isResourceView) {
                const resourceView = Object.assign(Object.assign({}, calendarOptions.value), { dayMinWidth: 212, stickyFooterScrollbar: true });
                calendarOptions.value = resourceView;
            }
            else {
                delete calendarOptions.value.dayMinWidth;
                delete calendarOptions.value.stickyFooterScrollbar;
            }
            fetchOnChange(fullCalendarRef.value);
        }
        function onChangeDatePicker(val) {
            const convertedDate = retainDateFromTimeZoneChange(val, moment.tz.guess(), props.timezone);
            fullCalendarRef.value.gotoDate(convertedDate);
            activeDate.value = new Date(val);
            fetchOnChange(fullCalendarRef.value);
        }
        function updateQuery() {
            const newRouter = props.router;
            newRouter.push({
                query: Object.assign(Object.assign(Object.assign({}, (calendarWidgetStates.calendarIds.length > 0 &&
                    calendarWidgetStates.activeView == 'calendar' && {
                    calendar_ids: calendarWidgetStates.calendarIds.join(','),
                })), (calendarWidgetStates.groupIds.length > 0 &&
                    calendarWidgetStates.activeView == 'group' && {
                    group_ids: calendarWidgetStates.groupIds.join(','),
                })), (calendarWidgetStates.userIds.length > 0 &&
                    calendarWidgetStates.activeView == 'user' && {
                    user_ids: calendarWidgetStates.userIds.join(','),
                })),
            });
        }
        watchEffect(() => {
            updateQuery();
        });
        function fetchFromLocal(key) {
            var _a;
            const loggedInUser = props.data.loggedInUserInfo;
            if ((_a = loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.permissions) === null || _a === void 0 ? void 0 : _a.assignedDataOnly)
                return;
            const data = localStorage.getItem(key);
            // if (!data) return []
            if (data)
                return data;
        }
        function setToLocal(key, value) {
            if (typeof value === 'string')
                localStorage.setItem(key, value);
            else if (typeof value === 'object') {
                localStorage.setItem(key, JSON.stringify(value));
            }
        }
        function initiateCalendarView() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            const localActiveView = fetchFromLocal(ACTIVE_VIEW_LS_KEY_FN(props.locationId, (_b = (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.loggedInUserInfo) === null || _b === void 0 ? void 0 : _b.id));
            let localCalendarIds = JSON.parse(fetchFromLocal(ACTIVE_CALENDARS_LS_KEY_FN(props.locationId, (_d = (_c = props === null || props === void 0 ? void 0 : props.data) === null || _c === void 0 ? void 0 : _c.loggedInUserInfo) === null || _d === void 0 ? void 0 : _d.id)) || '[]');
            let localUserIds = JSON.parse(fetchFromLocal(ACTIVE_USERS_LS_KEY_FN(props.locationId, (_f = (_e = props === null || props === void 0 ? void 0 : props.data) === null || _e === void 0 ? void 0 : _e.loggedInUserInfo) === null || _f === void 0 ? void 0 : _f.id)) || '[]');
            let localGroupIds = JSON.parse(fetchFromLocal(ACTIVE_GROUPS_LS_KEY_FN(props.locationId, (_h = (_g = props === null || props === void 0 ? void 0 : props.data) === null || _g === void 0 ? void 0 : _g.loggedInUserInfo) === null || _h === void 0 ? void 0 : _h.id)) || '[]');
            localCalendarIds = localCalendarIds.filter(id => props.calendars.some(calendar => calendar.id == id));
            localUserIds = localUserIds.filter(id => props.users.some(user => user.id == id));
            localGroupIds = localGroupIds.filter(id => props.groups.some(group => group.id == id));
            calendarWidgetStates.activeView = localActiveView
                ? localActiveView
                : ((_j = props === null || props === void 0 ? void 0 : props.users) === null || _j === void 0 ? void 0 : _j.length) > 0
                    ? 'user'
                    : 'calendar';
            if (!localActiveView) {
                setToLocal(ACTIVE_VIEW_LS_KEY_FN(props.locationId, (_l = (_k = props === null || props === void 0 ? void 0 : props.data) === null || _k === void 0 ? void 0 : _k.loggedInUserInfo) === null || _l === void 0 ? void 0 : _l.id), calendarWidgetStates.activeView);
            }
            calendarWidgetStates.calendarIds = _.isEmpty(localCalendarIds)
                ? []
                : localCalendarIds;
            calendarWidgetStates.userIds = _.isEmpty(localUserIds)
                ? (props === null || props === void 0 ? void 0 : props.users.some(user => (user === null || user === void 0 ? void 0 : user.id) == (props === null || props === void 0 ? void 0 : props.userId)))
                    ? [props === null || props === void 0 ? void 0 : props.userId]
                    : []
                : localUserIds;
            calendarWidgetStates.groupIds = _.isEmpty(localGroupIds) ? [] : localGroupIds;
        }
        function initiate() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    fullCalendarRef.value = fullCalendar.value.getApi();
                    currentDate.value = fullCalendarRef.value.currentData.viewTitle;
                    const activeView = fullCalendarRef.value.view;
                    const activeStartDate = activeView.activeStart;
                    const activeEndDate = activeView.activeEnd;
                    currentRange.value.start = activeStartDate.toISOString();
                    currentRange.value.end = activeEndDate.toISOString();
                    // set the initial date in calendarWidgetStates
                    calendarWidgetStates.start = currentRange.value.start;
                    calendarWidgetStates.end = currentRange.value.end;
                    calendarWidgetStates.locationId = props.locationId;
                    calendarWidgetStates.userId = props.userId;
                    calendarWidgetStates.timezone = props.timezone;
                    const storedValue = JSON.parse(localStorage.getItem(ACTIVE_TAB_SELECTION_FN(props.locationId, (_b = (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.loggedInUserInfo) === null || _b === void 0 ? void 0 : _b.id)));
                    if (storedValue &&
                        ['timeGridDay', 'timeGridWeek', 'dayGridMonth'].includes(storedValue.value)) {
                        toggleView(storedValue.value);
                    }
                    initiateCalendarView();
                    fullCalendarRef.value.today();
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        onBeforeUnmount(() => {
            var _a;
            calendarWidgetStates.events = [];
            calendarOptions.value.events = [];
            calendarWidgetStates.calendarIds = [];
            calendarWidgetStates.userIds = [];
            calendarWidgetStates.groupIds = [];
            calendarWidgetStates.activeView =
                ((_a = props === null || props === void 0 ? void 0 : props.users) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'user' : 'calendar';
        });
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            initiate();
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIContentWrap), {
                locale: _unref(GHLLanguageKeysMapper)[props.data.locale]
            }, {
                default: _withCtx(() => [
                    _createVNode(ToolBar, {
                        "current-range": currentRange.value,
                        "toggle-view": toggleView,
                        "handle-custom-navigation": handleCustomNavigation,
                        "current-date": currentDate.value,
                        "calendar-view-mode": initialView.value,
                        "time-zone": props.timezone,
                        locale: props.data.locale,
                        "location-id": props.locationId,
                        data: props.data
                    }, null, 8, ["current-range", "current-date", "calendar-view-mode", "time-zone", "locale", "location-id", "data"]),
                    _createElementVNode("div", _hoisted_1, [
                        (__props.isLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_unref(UISpin)),
                                    _hoisted_4
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_5, [
                            (initialView.value != 'dayGridMonth')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(getGMTOffset)(props.timezone)), 1))
                                : _createCommentVNode("", true),
                            _createVNode(_unref(FullCalendar), {
                                ref_key: "fullCalendar",
                                ref: fullCalendar,
                                options: calendarOptions.value
                            }, {
                                eventContent: _withCtx((arg) => [
                                    _createVNode(EventTile, {
                                        arg: arg,
                                        calendars: props.calendars,
                                        groups: props.groups,
                                        users: props.users,
                                        "logged-in-user-id": props.userId
                                    }, null, 8, ["arg", "calendars", "groups", "users", "logged-in-user-id"])
                                ]),
                                _: 1
                            }, 8, ["options"])
                        ]),
                        _createVNode(SideDrawer, {
                            "on-date-change": onChangeDatePicker,
                            timezone: props.timezone,
                            "active-date": activeDate.value,
                            calendars: _unref(assignEventColor)(props.calendars, 'calendar'),
                            users: _unref(assignEventColor)(props.users),
                            groups: _unref(assignEventColor)(props.groups, 'group'),
                            "user-id": props.userId,
                            "location-id": props.locationId,
                            data: __props.data
                        }, null, 8, ["timezone", "active-date", "calendars", "users", "groups", "user-id", "location-id", "data"])
                    ])
                ]),
                _: 1
            }, 8, ["locale"]));
        };
    }
});
